/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { RuntimeEntrypointProps } from './modalEntryPoint.entrypoint.types.tsx';

type ModalEntryPointComponent = EntryPointComponent<{}, {}, RuntimeEntrypointProps, {}>;

export const modalEntryPoint: EntryPoint<ModalEntryPointComponent, {}> = createEntryPoint({
	root: JSResourceForInteraction<ModalEntryPointComponent>(
		/* webpackChunkName: "async-polaris-component-ai-view-generation-modal-entrypoint" */ './AiViewGenerationModalEntryPoint.tsx',
	),
	getPreloadProps: () => {
		return {};
	},
});
